import React from 'react'
import {getUserSettings} from '../../storage'
import DefaultPurchase from './addpurchase'
import BatchPurchase from './batchpurchase'
import PurchaseModern from './purchasemodern'
import PurchaseCustom from './purchaseCustom01'
export default class PurchaseMode extends React.Component {


  render()  {
    let settings = getUserSettings()
    let options = settings.options
    if(typeof settings !== "undefined" && settings !== null && settings.item_track_batches) {
        return <BatchPurchase {...this.props} />
    }
    else if (typeof options !== "undefined" && options !== null && options.purchase_entry_mode == 'modern'){
      return <PurchaseModern {...this.props} />
    }
    else if (typeof options !== "undefined" && options !== null && options.purchase_entry_mode == 'custom_01'){
      return <PurchaseCustom {...this.props} />
    }
    else {
        return <DefaultPurchase {...this.props} />
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/purchase/purchaseselect.js